import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateFiltersFilesClients } from '../../interface/filters-files-clients.interface';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-filters-files-clients',
  templateUrl: './filters-files-clients.component.html',
  styleUrls: ['./filters-files-clients.component.scss'],
  providers: [DatePipe],
})
export class FiltersFilesClientsComponent {
  @Output() topFilter: EventEmitter<any> = new EventEmitter();
  @Output() public changeClientFileFilter = new EventEmitter<DateFiltersFilesClients>;
  @ViewChild('select') select: MatSelect;
  public formFilter!: FormGroup;
  public anioActual: number = new Date().getFullYear();
  public panelOpenState = false;
  selected = 'Personalizado';

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      start: [''],
      end: [''],
      generalFilter: [''],
      preference: [12],
    });
    this.filtroMeses(12);
  }

  preferences: any[] = [
    { value: 12, viewValue: '12 Meses' },
    { value: 24, viewValue: '24 Meses' },
    { value: 111, viewValue: 'Año Actual ('+this.anioActual+')' },
    { value: 222, viewValue: 'Año '+(this.anioActual-1) },
    { value: 333, viewValue: 'Año '+(this.anioActual-2) },
    { value: 1, viewValue: 'Todo'},
    { value: 0, viewValue: 'Personalizado' }
  ];

  addPreference(value: number, viewValue: string) {
    this.preferences.push({ value: value, viewValue: viewValue });
}

  filtroGeneral(event: any) {
    this.sendUpdatedFilters();
  }

  private sendUpdatedFilters(){
    const {start, end, generalFilter, preference} = this.formFilter.value;
    const startISO: string = (typeof start === 'string') ?  start : new Date(start).toISOString();
    const endISO : string = (typeof end === 'string') ? end : new Date(end).toISOString();
    const filterClientFilter: DateFiltersFilesClients = {
      start: startISO,
      end: endISO,
      search: generalFilter,
      preference: preference
    };
    this.changeClientFileFilter.emit(filterClientFilter);
  }

  // Método para actualizar dinámicamente el valor de la opción de filtro
  actualizarOpcionFiltro() {
    const valorPersonalizado = 'personalizado';

    // Verificar si se ha utilizado el rango de días
    if (
      this.formFilter.get('start')!.value &&
      this.formFilter.get('end')!.value &&
      !this.opcionesIncluyenPersonalizado()
    ) {
      // Agregar la opción "Personalizado" si no está en la lista
      this.preferences.push({
        value: valorPersonalizado,
        viewValue: 'Personalizado',
      });

      // Actualizar el valor del formulario
      this.formFilter.patchValue({
        preference: valorPersonalizado,
      });
    } else if (
      (!this.formFilter.get('start')!.value ||
        !this.formFilter.get('end')!.value) &&
      this.opcionesIncluyenPersonalizado()
    ) {
      // Si no se ha utilizado el rango de días, eliminar la opción "Personalizado"
      this.removerPersonalizado();
    }
  }

  opcionesIncluyenPersonalizado() {
    return this.preferences.some((opcion) => opcion.value === 'personalizado');
  }

  // Método para remover la opción "Personalizado" de las opciones
  removerPersonalizado() {
    this.preferences = this.preferences.filter(
      (opcion) => opcion.value !== 'personalizado'
    );
  }

  filtroMeses(number: number) {
    /*if(number === 12 || number === 24)
    {
      end = new Date().toISOString();
      start = new Date(new Date().setMonth(new Date().getMonth() - number)).toISOString();
    }
    else if(number == null) {
      end = new Date().toISOString();
      start = new Date('01-01-' + new Date().getFullYear() ).toISOString();
    }*/

    let end, start;
    const now = new Date();
    
    if (number === 12 || number === 24) {
      end = now.toISOString();
      start = new Date(now.setMonth(now.getMonth() - number)).toISOString();
    } else if (number === 111) {
      end = now.toISOString();
      start = new Date(now.getFullYear(), 0, 1).toISOString(); // Inicio de este año
    } else if (number === 222) {
      end = new Date(now.getFullYear() - 1, 11, 30).toISOString(); // 30 de diciembre del año pasado
      start = new Date(now.getFullYear() - 1, 0, 1).toISOString(); // 1 de enero del año pasado
    } else if (number === 333) {
      end = new Date(now.getFullYear() - 2, 11, 30).toISOString(); // 30 de diciembre de hace dos años
      start = new Date(now.getFullYear() - 2, 0, 1).toISOString(); // 1 de enero de hace dos años
    } else if (number === 1) {
      end = now.toISOString();
      start = new Date(now.getFullYear() - 124, 0, 1).toISOString(); // 1 de enero de hace 124 años
    }

    this.formFilter.patchValue({
      end: end,
      start: start,
    });

    const filterClientFilter: DateFiltersFilesClients = {
      start: start,
      end: end,
      search: this.formFilter.get('generalFilter')!.value,
      preference: this.formFilter.get('preference')!.value
    };

    this.changeClientFileFilter.emit(filterClientFilter);
  }

  filtrarPorFecha() {
    const endValue = this.formFilter.controls['end']?.value;
    const startValue = this.formFilter.controls['start']?.value;
    this.formFilter.controls['preference']?.setValue(0);

    this.sendUpdatedFilters();
  }
}
